import { TypographyOptions } from '@mui/material/styles/createTypography';

const typographyVariables = {
  fontSize: {
    'text-xxs': '0.625rem', // 10px
    'text-xs': '0.75rem', // 12px
    'text-sm': '0.875rem', // 14px
    'text-md': '1rem', // 16px
    'text-lg': '1.125rem', // 18px
    'text-xl': '1.25rem', // 20px
    'display-xs': '1.5rem', // 24px
    'display-sm': '1.875rem', // 30px
    'display-md': '2.25rem', // 36px
  },
  lineHeight: {
    'text-xs': '16px',
    'text-sm': '20px',
    'text-md': '24px',
    'text-lg': '24px',
    'text-xl': '28px',
    'display-xs': '32px',
    'display-sm': '40px',
    'display-md': '48px',
  },
};

export const createTypography = (): TypographyOptions => {
  return {
    fontFamily: 'Helvetica Neue, Poppins, Inter, Arial, sans-serif', //Helvetica Neue is deprecated and will be remove
    // Helvetica Neue Variants (Deprecated)
    body1: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.25,
    },
    body2: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.57,
    },
    button: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: 1.25,
      minWidth: '64px',
      textTransform: 'none',
      paddingLeft: '0.25rem',
      paddingRight: '0.25rem',
    },
    caption: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: 1.66,
    },
    subtitle1: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.57,
    },
    subtitle2: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.57,
    },
    overline: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontSize: '0.75rem',
      fontWeight: 600,
      letterSpacing: '0.5px',
      lineHeight: 2.5,
      textTransform: 'uppercase',
    },
    h1: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontWeight: 700,
      fontSize: '3.5rem',
      lineHeight: 1.2,
    },
    h2: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontWeight: 700,
      fontSize: '3rem',
      lineHeight: 1.2,
    },
    h3: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontWeight: 700,
      fontSize: '2.25rem',
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontWeight: 700,
      fontSize: '2rem',
      lineHeight: 1.2,
    },
    h5: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: 1.2,
    },
    h6: {
      fontFamily: 'Helvetica Neue, sans-serif',
      fontWeight: 700,
      fontSize: '1.125rem',
      lineHeight: 1.2,
    },

    // Poppins Variants
    'Poppins/Heading-1': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600, // SemiBold
      fontSize: typographyVariables.fontSize['display-md'],
      lineHeight: typographyVariables.lineHeight['display-md'],
      textTransform: 'none',
    },
    'Poppins/Heading-2': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
      fontSize: typographyVariables.fontSize['display-sm'],
      lineHeight: typographyVariables.lineHeight['display-sm'],
      textTransform: 'none',
    },
    'Poppins/Heading-3': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
      fontSize: typographyVariables.fontSize['display-xs'],
      lineHeight: typographyVariables.lineHeight['display-xs'],
      textTransform: 'none',
    },
    'Poppins/Heading-4': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
      fontSize: typographyVariables.fontSize['text-xl'],
      lineHeight: typographyVariables.lineHeight['text-xl'],
      textTransform: 'none',
    },
    'Poppins/Heading-5': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
      fontSize: typographyVariables.fontSize['text-lg'],
      lineHeight: typographyVariables.lineHeight['text-lg'],
      textTransform: 'none',
    },
    'Poppins/Heading-6': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
      fontSize: typographyVariables.fontSize['text-md'],
      lineHeight: typographyVariables.lineHeight['text-md'],
      textTransform: 'none',
    },
    'Poppins/Subheading-xl': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 500,
      fontSize: typographyVariables.fontSize['text-xl'],
      lineHeight: typographyVariables.lineHeight['text-xl'],
      textTransform: 'none',
    },
    'Poppins/Subheading-lg': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 500,
      fontSize: typographyVariables.fontSize['text-lg'],
      lineHeight: typographyVariables.lineHeight['text-lg'],
      textTransform: 'none',
    },
    'Poppins/Subheading-md': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 500,
      fontSize: typographyVariables.fontSize['text-md'], // 16px
      lineHeight: typographyVariables.lineHeight['text-md'], // 24px
      textTransform: 'none',
    },
    'Poppins/Subheading-sm': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 500,
      fontSize: typographyVariables.fontSize['text-sm'], // 14px
      lineHeight: typographyVariables.lineHeight['text-sm'], // 20px
      textTransform: 'none',
    },
    'Poppins/Subheading-xs': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 500,
      fontSize: typographyVariables.fontSize['text-xs'], // 12px
      lineHeight: typographyVariables.lineHeight['text-xs'], // 16px
      textTransform: 'none',
    },
    'Poppins/Body-md': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
      fontSize: typographyVariables.fontSize['text-md'],
      lineHeight: typographyVariables.lineHeight['text-md'],
      textTransform: 'none',
    },
    'Poppins/Body-sm': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
      fontSize: typographyVariables.fontSize['text-sm'],
      lineHeight: typographyVariables.lineHeight['text-sm'],
      textTransform: 'none',
    },
    'Poppins/Body-xs': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
      fontSize: typographyVariables.fontSize['text-xs'],
      lineHeight: typographyVariables.lineHeight['text-xs'],
      textTransform: 'none',
    },

    // Inter Variants
    'Inter/Heading-1': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 600,
      fontSize: typographyVariables.fontSize['text-xl'],
      lineHeight: typographyVariables.lineHeight['text-xl'],
      textTransform: 'none',
    },
    'Inter/Heading-2': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 600,
      fontSize: typographyVariables.fontSize['text-lg'],
      lineHeight: typographyVariables.lineHeight['text-lg'],
      textTransform: 'none',
    },
    'Inter/Heading-3': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 600,
      fontSize: typographyVariables.fontSize['text-md'],
      lineHeight: typographyVariables.lineHeight['text-md'],
      textTransform: 'none',
    },
    'Inter/Heading-4': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 600,
      fontSize: typographyVariables.fontSize['text-sm'],
      lineHeight: typographyVariables.lineHeight['text-sm'],
      textTransform: 'none',
    },
    'Inter/Subheading-xl': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 500,
      fontSize: typographyVariables.fontSize['text-xl'],
      lineHeight: typographyVariables.lineHeight['text-xl'],
      textTransform: 'none',
    },
    'Inter/Subheading-md': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 500,
      fontSize: typographyVariables.fontSize['text-md'],
      lineHeight: typographyVariables.lineHeight['text-md'],
      textTransform: 'none',
    },
    'Inter/Subheading-sm': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 500,
      fontSize: typographyVariables.fontSize['text-sm'],
      lineHeight: typographyVariables.lineHeight['text-sm'],
      textTransform: 'none',
    },
    'Inter/Subheading-xs': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 500,
      fontSize: typographyVariables.fontSize['text-xs'],
      lineHeight: typographyVariables.lineHeight['text-xs'],
      textTransform: 'none',
    },
    'Inter/Body-md': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400,
      fontSize: typographyVariables.fontSize['text-md'],
      lineHeight: typographyVariables.lineHeight['text-md'],
      textTransform: 'none',
    },
    'Inter/Body-sm': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400,
      fontSize: typographyVariables.fontSize['text-sm'],
      lineHeight: typographyVariables.lineHeight['text-sm'],
      textTransform: 'none',
    },
    'Inter/Body-xs': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400,
      fontSize: typographyVariables.fontSize['text-xs'],
      lineHeight: typographyVariables.lineHeight['text-xs'],
      textTransform: 'none',
    },
    'Inter/LABEL-SM': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 500,
      fontSize: typographyVariables.fontSize['text-xxs'],
      lineHeight: typographyVariables.lineHeight['text-xs'],
      textTransform: 'uppercase',
    },
  };
};

declare module '@mui/material/styles' {
  interface TypographyVariants {
    'Poppins/Heading-1': React.CSSProperties;
    'Poppins/Heading-2': React.CSSProperties;
    'Poppins/Heading-3': React.CSSProperties;
    'Poppins/Heading-4': React.CSSProperties;
    'Poppins/Heading-5': React.CSSProperties;
    'Poppins/Heading-6': React.CSSProperties;
    'Poppins/Subheading-xl': React.CSSProperties;
    'Poppins/Subheading-lg': React.CSSProperties;
    'Poppins/Subheading-md': React.CSSProperties;
    'Poppins/Subheading-sm': React.CSSProperties;
    'Poppins/Subheading-xs': React.CSSProperties;
    'Poppins/Body-md': React.CSSProperties;
    'Poppins/Body-sm': React.CSSProperties;
    'Poppins/Body-xs': React.CSSProperties;
    'Inter/Heading-1': React.CSSProperties;
    'Inter/Heading-2': React.CSSProperties;
    'Inter/Heading-3': React.CSSProperties;
    'Inter/Heading-4': React.CSSProperties;
    'Inter/Subheading-xl': React.CSSProperties;
    'Inter/Subheading-md': React.CSSProperties;
    'Inter/Subheading-sm': React.CSSProperties;
    'Inter/Subheading-xs': React.CSSProperties;
    'Inter/Body-md': React.CSSProperties;
    'Inter/Body-sm': React.CSSProperties;
    'Inter/Body-xs': React.CSSProperties;
    'Inter/LABEL-SM': React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    'Poppins/Heading-1'?: React.CSSProperties;
    'Poppins/Heading-2'?: React.CSSProperties;
    'Poppins/Heading-3'?: React.CSSProperties;
    'Poppins/Heading-4'?: React.CSSProperties;
    'Poppins/Heading-5'?: React.CSSProperties;
    'Poppins/Heading-6'?: React.CSSProperties;
    'Poppins/Subheading-xl'?: React.CSSProperties;
    'Poppins/Subheading-lg'?: React.CSSProperties;
    'Poppins/Subheading-md'?: React.CSSProperties;
    'Poppins/Subheading-sm'?: React.CSSProperties;
    'Poppins/Subheading-xs'?: React.CSSProperties;
    'Poppins/Body-md'?: React.CSSProperties;
    'Poppins/Body-sm'?: React.CSSProperties;
    'Poppins/Body-xs'?: React.CSSProperties;
    'Inter/Heading-1'?: React.CSSProperties;
    'Inter/Heading-2'?: React.CSSProperties;
    'Inter/Heading-3'?: React.CSSProperties;
    'Inter/Heading-4'?: React.CSSProperties;
    'Inter/Subheading-xl'?: React.CSSProperties;
    'Inter/Subheading-md'?: React.CSSProperties;
    'Inter/Subheading-sm'?: React.CSSProperties;
    'Inter/Subheading-xs'?: React.CSSProperties;
    'Inter/Body-md'?: React.CSSProperties;
    'Inter/Body-sm'?: React.CSSProperties;
    'Inter/Body-xs'?: React.CSSProperties;
    'Inter/LABEL-SM'?: React.CSSProperties;
  }
}

// Override TypographyPropsVariantOverrides to allow custom variants
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    'Poppins/Heading-1': true;
    'Poppins/Heading-2': true;
    'Poppins/Heading-3': true;
    'Poppins/Heading-4': true;
    'Poppins/Heading-5': true;
    'Poppins/Heading-6': true;
    'Poppins/Subheading-xl': true;
    'Poppins/Subheading-lg': true;
    'Poppins/Subheading-md': true;
    'Poppins/Subheading-sm': true;
    'Poppins/Subheading-xs': true;
    'Poppins/Body-md': true;
    'Poppins/Body-sm': true;
    'Poppins/Body-xs': true;
    'Inter/Heading-1': true;
    'Inter/Heading-2': true;
    'Inter/Heading-3': true;
    'Inter/Heading-4': true;
    'Inter/Subheading-xl': true;
    'Inter/Subheading-md': true;
    'Inter/Subheading-sm': true;
    'Inter/Subheading-xs': true;
    'Inter/Body-md': true;
    'Inter/Body-sm': true;
    'Inter/Body-xs': true;
    'Inter/LABEL-SM': true;
  }
}
